<script setup lang="ts">
import Dropdown from '@/components/Dropdown.vue';
import { shallowRef } from 'vue';
import { useFilters } from '.';

const { filters, filter } = useFilters();

const options = shallowRef([
  { name: 'Prijs oplopend', value: 'price-asc' },
  { name: 'Prijs aflopend', value: 'price-desc' },
]);
</script>

<template>
  <Dropdown
    inputClass="sort-class"
    dropdownClass="dropdown-class"
    placeholder="Sorteren"
    v-model:value="filters.order"
    :options="options"
    @update:value="filter"
  />
</template>

<style>
.sort-class {
  padding: 12px 24px !important;
  height: 48px !important;
  background-color: transparent !important;
  border: 1px solid #e3e3e3;
  color: #1a4c8d !important;
  font-family: din-condensed-variable, sans-serif !important;
  font-size: 19px;
  font-style: normal;
  font-weight: 600;
  line-height: 124%; /* 23.56px */
  text-transform: uppercase;
}
</style>
